export default {"src":"/_next/static/media/discount.8730f6c1.svg","height":18,"width":15,"blurWidth":0,"blurHeight":0};